import React, { useState } from 'react'
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { useNavigate } from 'react-router-dom'
import { Button, Icon } from '@nazka/nazka.mapframe.components'
import { faCheck } from '@fortawesome/pro-light-svg-icons'
import { modulesTopics } from '../course-related-components.constants'
import { getProgress, isModuleCompleted, eraseProgress } from '../course-related-components.util'

import './course-module-selector.styl'

function CourseModuleSelector() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [progress, setProgress] = useState(getProgress())

  return (
    <div className="course-module-selector">
      <div className="course-module-selector__cta">
        {progress.completedModules.length > 0 && (
        <Button
          css={{
            borderRadius: '8px',
            '&:hover': {
              color: 'white',
            },
          }}
          layout="outlined"
          onClick={() => {
            eraseProgress()
            setProgress(getProgress())
          }}
        >
          {t('Reset progress')}
        </Button>
        )}
        <div className="my-fifth-learn-step">
          <Button
            css={{
              borderRadius: '8px',
              color: 'white',
              '&:hover': {
                color: 'white',
              },
            }}
            onClick={() => navigate('/learn/quiz')}
          >
            {t('Take Quiz')}
          </Button>

        </div>
      </div>
      <h2 className="course-module-selector__title">{t('Choose a module')}</h2>
      <div className="course-module-selector__modules__wrapper my-second-learn-step">
        {modulesTopics.map(module => (
          <button
            key={module.id}
            className="course-module-selector__module"
            type="button"
            onClick={() => navigate(`/learn/module/${module.id}`)}
          >
            <img className="course-module-selector__img" src={module.icon} alt={module.title} />
            <h4 className="course-module-selector__item-title">{t(module.title)}</h4>
            <p className="course-module-selector__description">{t(module.description)}</p>
            <div className={isModuleCompleted(module.id) ? 'course-module-selector__btn-wrapper course-module-selector__btn-wrapper--completed' : 'course-module-selector__btn-wrapper'}>
              {isModuleCompleted(module.id) && <Icon icon={faCheck} size="16px" className="course-module-selector__icon" />}
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default CourseModuleSelector